export const hotelRegulationsText = {
    "en-US": `
   
<h4>Swissstay Apartments & Villas -- House Rules & Terms and Conditions</h4>
<p>
Welcome to our furnished Swissstay Apartments & Villas in Switzerland!
We're absolutely thrilled to have you as our guest and want to make your stay as enjoyable, safe, and smooth as possible.
Please take a moment to read through the following <b>House Rules & Terms and Conditions</b> a blend of helpful guidelines and legal basics that ensure everything runs like clockwork (Swiss-style 🕒).
</p>
<br>
<h5>1. Check-In & Check-Out</h5>
<p><b>• Check-in:</b> From 4:00 PM onwards - it's your time to shine!<br>
<b>• Check-out:</b> By 11:00 AM. Please respect this to avoid additional charges and help us prepare for the next guest.<br>
<b>• Self-Check-In:</b> Our keybox system makes it easy! You'll receive check-in instructions via email before your arrival. Make sure to check your inbox and spam folder.<br>
<b>• Important:</b> You <b>must</b> complete the Self-Check-in Form (sent 1 day before arrival) and ensure full payment before your arrival. We are not responsible for failed check-ins due to missing information or unpaid bookings.<br>
</p>
<br>
<h5>2. Deposit & Damages</h5>
<p><b>•</b> A <b>safety deposit</b> will be blocked on your credit card prior to your stay. This is released no later than 7 days after check-out, provided there are no damages or policy violations. 
<b>•</b> Please report any damage, big or small. Minor accidents (like a broken glass) are no big deal, but larger issues may result in deductions or charges.
<h5>3. Quiet Hours & Respect for Neighbors</h5>
<p>
<b>• Quiet times:</b><br>
    <span> <b>-</b> Weekdays: 12:00 PM-1:00 PM and 10:00 PM 7:00 AM</span><br>
    <span> <b>-</b> Sundays & public holidays: full-day rest </span>
Please be mindful of neighbors and avoid loud music, shouting, or parties during these times.
</p><br>
<h5>4. No Parties or Events</h5>
<p>
<span>We love good vibes but:</span><br>
<b>•</b> No parties or events are allowed.
<b>•</b> Unregistered guests are not permitted on the premises.
<b>•</b> Only the number of guests stated in the booking may stay overnight.
</p><br>
<h5>5. No Smoking or Vaping</h5>
<p>
<b>•</b> All apartments are 100% smoke-free. Smoking indoors is strictly prohibited and will result in a minimum CHF 250 cleaning fee.
<b>•</b> Please use designated outdoor areas if you need to smoke and dispose of cigarette butts responsibly.
</p><br>
<h5>6. Kitchen Use & Cleanliness</h5>
<p>
<b>•</b> Cook up a storm! Our fully equipped kitchens are all yours.
<b>•</b> Use the extractor hood while cooking, and <b>don't forget to turn off the stove</b> afterward.
<b>•</b> Kindly leave the kitchen in a clean, tidy state.
<b>•</b> Please <bwash your dishes</b> before departure. 
</p><br>
<h5>7. Trash Disposal</h5>
<p>
<b>•</b> Switzerland has specific trash disposal rules. We provide a "communal trash bag" - ask us if you need more.
<b>•</b> Please take out the trash before departure to help us keep the space clean and green.
</p><br>
<h5>8. Furniture & Interiors</h5>
<p>
<b>•</b> Treat furniture and items with care.
<b>•</b> <b>Do not rearrange furniture</b>, and please avoid damaging walls or floors.
<b>•</b> Costs for damage beyond the security deposit will be charged to you.
</p><br>
<h5>9. No Pets</h5>
<p>
<span>For hygiene and allergy reasons, <b>pets are not allowed</b>.</span>
</p><br>
<h5>10. No Illegal Activities</h5>
<p>
<b>•</b> The use or possession of <b>illegal substances</b> is strictly prohibited.
<b>•</b> <b>Prostitution is forbidden</b>. Violators will be fined <b>CHF 1,000</b> and reported to authorities.
</p><br>
<h5>11. Bedrooms Are for Rest</h5>
<p>
<b>•</b> Please avoid bringing <b>food or drinks into the bedrooms</b> to prevent stains and spills.
</p><br>
<h5>12. Lost & Found</h5>
<p>
<b>•</b> Forgot something? If found, we'll store it for one week at our office.
<b>•</b> Contact us before visiting the office - we do not offer shipping services.
</p><br>
<h5>13. Emergencies</h5>
<p>
<span>In real emergencies, call the local emergency numbers:</span><br>
<b>•</b> <b>Police</b>: 117
<b>•</b> <b>Fire</b>: 118
<b>•</b> <b>Ambulance</b: 144
<b>•</b> <b>Poison Control</b>: 145
</p><br>
<h5>14. Communication</h5>
<p>
<b>•</b> For all <b>non-emergency inquiries</b>, please contact us via your <b>booking channel</b>.
<b>•</b> Our team is always happy to help, but communication outside the platform may not be monitored in real time.
</p><br>
<h5>15. Cleaning & Mid-Stay Services</h5>
<p>
<b>•</b> Your apartment will be <b>professionally cleaned before your arrival</b>.
<b>•</b> No intermediate cleanings are included during your stay.
<b>•</b> Need fresh towels or extra cleaning? Reach out - services are available for an additional fee.
</p><br>
<h5>16. Key Care</h5>
<p>
<b>•</b> Please handle keys with care.
<b>•</b> <b>Lost keys will incur a replacement fee</b> of CHF 500-800 depending on the system.
</p><br>
<h5>17. Legal Framework</h5>
<p>
<b>•</b> These rules are part of the <b>General Terms and Conditions (GTC)</b> between you (the Guest) and us (Swissstay).
<b>•</b> The GTC apply from the moment of booking confirmation.
<b>•</b> In case of any conflict, Swiss law applies, and invalid clauses do not affect the remaining terms.
</p><br>
<h5>18. Your Feedback Matters</h5>
<p>
<span>We're all ears - seriously! If anything's not right or could be improved, please let us know.
Contact:📧  <b>team@swissstay.ch</b> or via your booking platform.
</span>
</p><br>
<p>Thank you for choosing Swissstay Apartments & Villas.</p>
<p>Let's make your stay not just comfortable, but unforgettable! 🎉 😊</p>

`};
